import firebase from "firebase/compat/app";
import "firebase/compat/database";

const firebaseConfig = {
  apiKey: "AIzaSyDkX_rxhE1XhXrtXY03QBIuT2TSN_kNDlw",
  authDomain: "kuis-41208.firebaseapp.com",
  // PASTI KAN URL DATABASE MEMILIKI REGION (asia-southeast1)
  databaseURL: "https://kuis-41208-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kuis-41208",
  storageBucket: "kuis-41208.firebasestorage.app",
  messagingSenderId: "884861868353",
  appId: "1:884861868353:web:70963737d4f88dab28e9c0"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Tambahkan opsi pemaksaan protokol HTTP/Long-polling jika Websocket terblokir oleh ISP/Network
const db = firebase.database();

export { db };